import { render, staticRenderFns } from "./ProCard2.vue?vue&type=template&id=0349126a&scoped=true"
import script from "./ProCard2.vue?vue&type=script&lang=js"
export * from "./ProCard2.vue?vue&type=script&lang=js"
import style0 from "./ProCard2.vue?vue&type=style&index=0&id=0349126a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0349126a",
  null
  
)

export default component.exports